import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { allValidations } from "../../utils/formValidations";
import { HOST } from "../../constants";
import { addStyleGuide, fetchStyleGuideDetails, updateStyleGuide } from "../../redux/actions/styleGuideAction";
import { showFormErrors } from "../../utils/commonFunctions";

export default function StyleGuideContainer() {
    const dispatch = useDispatch();
    const history = useHistory();

    const { styleGuideDetails } = useSelector((state) => state.style);

    const { id } = useParams();
    const [formType, setFormType] = useState("EDIT");

    const [data, setData] = useState({
        singleImage: "",
        name: "",
        paragraph: "",
    });

    useEffect(() => {
        if (id) {
            dispatch(fetchStyleGuideDetails(id));
        }
    }, [id, dispatch]);

    useEffect(() => {
        if (id) {
            setData({
                name: styleGuideDetails.name,
                singleImage: styleGuideDetails.singleImage,
                paragraph: styleGuideDetails.paragraph,
            });
        }
    }, [id, styleGuideDetails]);

    const [loading, setLoading] = useState(false);

    const handleChange = ({ name, value }) => {
        const ignoreFields = [];

        let formErrors = {};
        formErrors = allValidations(name, value, data, ignoreFields);
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    const addStyle = () => {
        const updatedData = { ...data };
        if (Array.isArray(updatedData.singleImage) && updatedData.singleImage.length > 0) {
            updatedData.singleImage = updatedData.singleImage[0];
        }
        if (showFormErrors(updatedData, setData)) {
            if (id) {
                dispatch(updateStyleGuide(id, updatedData, history));
            } else {
                dispatch(addStyleGuide(updatedData, history));
            }
        }
    };

    return {
        dispatch,
        id,
        data,
        setData,
        handleChange,
        formType,
        setFormType,
        loading,
        addStyle,
        history,
        HOST,
        setLoading,
    };
}
